import React from "react";
import { cn } from "@/lib/utils";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { de } from "date-fns/locale";
import { registerLocale } from "react-datepicker";

registerLocale("de", de);

type DatePickerProps<T> = {
  value: Date | null;
  setMidnight?: boolean;
  onChange: (value: Date | null) => void;
  className?: string;
};

export function DatePickerInput<T>({
  value,
  setMidnight = false,
  onChange,
  className = ""
}: DatePickerProps<T>) {
  return (
    <DatePicker
        selected={value}
        locale="de"
        onChange={(date: Date | null) => {
          if (date) {
            const cleaned = new Date(date.getFullYear(), date.getMonth(), date.getDate());
            if(setMidnight)
              cleaned.setHours(23,59,59,0);
            onChange(cleaned);
          } else {
            onChange(null);
          }

        }}
        dateFormat="dd.MM.yyyy"
        className={cn(
          "flex h-8 w-full rounded-md border border-input dark:border-zinc-400 bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className
        )}
       
      />
  );
}

